/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'caret': {
    viewBox: '0 0 24 24',
    data: '<polygon points="12 15.016 6.688 9.703 7.439 8.952 12 13.514 16.561 8.952 17.313 9.703 12 15.016" style="fill-rule:evenodd"/>'
  }
})
